// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__19a64","header":"MergedInvoice_header__31brN"};